import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectDocumentSetId } from 'services/documentSets/selectors';
import { selectDocumentsArray } from 'services/documents/selectors';

const selectDocumentsCount = createDeepEqualSelector(
    [selectDocumentSetId, selectDocumentsArray],
    (documentSetId, documents) =>
        documents.filter((document) => document.documentSetId === documentSetId)
            .length
);

export const makeSelectDocumentsCount = (): typeof selectDocumentsCount =>
    selectDocumentsCount;
